// Shared Icons
export const ExternalLink = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
    <polyline points="15 3 21 3 21 9" />
    <line x1="10" y1="14" x2="21" y2="3" />
  </svg>
);

export const CloseIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

// Role colors used across components
const ROLE_COLORS = {
  "Executive / C-Suite": { bg: "#ffcfc9", text: "#9a2617" },
  "Senior Director / Director": { bg: "#d4e4fc", text: "#1e4a8a" },
  "Manager": { bg: "#d4f5e9", text: "#0e5c3c" },
  "Staff": { bg: "#fef3c7", text: "#92400e" },
};

export const getRoleColor = (roleName) => {
  return ROLE_COLORS[roleName] || { bg: "#e5e7eb", text: "#374151" };
};

// Shared RoleBadge component
export function RoleBadge({ role, variant = "default", className = "" }) {
  const colors = getRoleColor(role);

  const baseClass = variant === "table"
    ? "table-role-badge"
    : variant === "accordion"
      ? "accordion-role-badge"
      : variant === "panel"
        ? "panel-role-badge"
        : "role-badge";

  const displayName = variant === "table" ? role.split(' / ')[0] : role;

  return (
    <span
      className={`${baseClass} ${className}`}
      style={{ backgroundColor: colors.bg, color: colors.text }}
    >
      {displayName}
    </span>
  );
}
